export enum REASON_FOR_UPDATING_USER {
  VISIT = 'VISIT',
  LOGIN = 'LOGIN',
  REGISTRATION = 'REGISTRATION',
  DEPOSIT = 'DEPOSIT',
  REFRESH_STATUSES = 'REFRESH_STATUSES',
  EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION',
}
